document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('.cart-popup-wrapper');
  const closeButton = document.querySelector('#close-popup');
  const updateButton = document.querySelector('#update-product');
  const sizeGrid = document.querySelector('#popup-options');
  const caratLookGrid = document.querySelector('#popup-options-carat-look');
  const metalSwatches = document.querySelector('#popup-metal-selection');
  const quantitySelect = document.querySelector('#popup-qty');
  const titleEl = document.querySelector('#popup-title');
  const priceEl = document.querySelector('#popup-price');
  const oldPriceEl = document.querySelector('#popup-old-price');
  const imageEl = document.querySelector('#popup-image');
  const metalNameEl = document.querySelector('#popup-metal-name'); // Element to display selected metal name

  let currentItemKey = null;
  let currentVariantId = null;
  let productDataObj = null;

  // Close Button functionality
  closeButton.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  // Open modal on edit button click using event delegation
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.edit-product-item');
    if (!btn) return;

    const itemData = btn.getAttribute('data-item');
    const cartData = btn.getAttribute('data-cart');
    const productDataJson = btn.getAttribute('data-item-product'); // Get data-item-product attribute

    if (!itemData || !cartData || !productDataJson) return;  // Exit if any required data is missing

    let item = null;
    let cart = null;

    try {
      item = JSON.parse(itemData.replace(/&quot;/g, '"'));
      cart = JSON.parse(cartData.replace(/&quot;/g, '"'));
      productDataObj = JSON.parse(productDataJson.replace(/&quot;/g, '"')); // Parse the product data JSON
    } catch (error) {
      console.error('Error parsing JSON:', error);
      return;  // Exit if JSON parsing fails
    }

    currentItemKey = item.key;
    currentVariantId = item.variant_id; 

    titleEl.textContent = item.title || 'Untitled';
    imageEl.src = item.image || ''; // Set the image initially
    priceEl.textContent = formatPrice(item.price);
    oldPriceEl.textContent = item.original_price > item.price ? formatPrice(item.original_price) : '';

    // Fetch full product from Shopify to get all variants
    fetch(`/products/${item.handle}.js`)
      .then(res => res.json())
      .then(product => {
        // Set the product data
        productDataObj = product;

        // Get selectedSize and selectedMetal from item options dynamically
        const selectedSize = getOptionValue(item.options_with_values, 'size');
        const selectedMetal = getOptionValue(item.options_with_values, 'color') || getOptionValue(item.options_with_values, 'metal');
        const selectedCaratLook = getOptionValue(item.options_with_values, 'carat') || getOptionValue(item.options_with_values, 'carat look');

        // Update the metal name immediately when the popup opens
        if (metalNameEl && selectedMetal) {
          metalNameEl.textContent = selectedMetal;  // Display the selected metal name
        }

        // Debugging logs to check if product data is correctly fetched
        console.log('Fetched Product Data:', productDataObj);

                 // Check if product has variants and hide/show divs accordingly
         const hasVariants = product && product.variants && product.variants.length > 1;
         const metalDiv = document.querySelector('.cart-popup-metal');
         const sizeDiv = document.querySelector('.cart-popup-size');
         const caratDiv = document.querySelector('.cart-popup-carat-look');
         
         // Find which options exist in the product
         const hasMetalOption = product.options.some(opt => 
           opt.name.toLowerCase().includes('metal') || 
           opt.name.toLowerCase().includes('color') ||
           opt.name.toLowerCase().includes('material')
         );
         const hasSizeOption = product.options.some(opt => 
           opt.name.toLowerCase().includes('size') ||
           opt.name.toLowerCase().includes('dimension') ||
           opt.name.toLowerCase().includes('measurement')
         );
          const hasCaratOption = product.options.some(opt =>
            opt.name.toLowerCase().includes('carat') ||
            opt.name.toLowerCase().includes('carat look') ||
            opt.name.toLowerCase().includes('ct')
        );
         
         if (metalDiv) {
           metalDiv.style.display = (hasVariants && hasMetalOption) ? 'block' : 'none';
         }
         if (sizeDiv) {
           sizeDiv.style.display = (hasVariants && hasSizeOption) ? 'block' : 'none';
         }
         if (caratDiv) {
          caratDiv.style.display = (hasVariants && hasCaratOption) ? 'block' : 'none';
        }

        // Only render options if there are variants
        if (hasVariants) {
          // Pass selectedSize and selectedMetal to both functions
          renderSizeOptions(product, selectedSize, selectedMetal, selectedCaratLook);
          renderMetalSwatches(product, selectedSize, selectedMetal, selectedCaratLook);
          renderCaratLookOptions(product, selectedCaratLook, selectedSize, selectedMetal);
          updateSelectedVariant(product);

          // Update the variant image for selected size and metal after the product is fetched
          if (productDataObj) {
            updateVariantImage(productDataObj, selectedSize, selectedMetal, selectedCaratLook); // Update image for selected variant
          }
        }
      });

    quantitySelect.innerHTML = '';
    for (let i = 1; i <= 10; i++) {
      const opt = document.createElement('option');
      opt.value = i;
      opt.textContent = i;
      if (i == item.quantity) opt.selected = true;
      quantitySelect.appendChild(opt);
    }

    modal.style.display = 'flex';  // Show modal
  });

  // Helper to get the exact value from product options for a given type and selected value
  function getExactOptionValue(product, optionType, selectedValue) {
    // Support multiple option type keywords
    const optionKeywords = {
      'size': ['size', 'dimension', 'measurement'],
      'metal': ['metal', 'color', 'material'],
      'color': ['color', 'metal', 'material'],
      'carat': ['carat', 'carat look', 'ct']
    };
    
    const keywords = optionKeywords[optionType] || [optionType];
    const optionIndex = product.options.findIndex(opt => 
      keywords.some(keyword => opt.name.toLowerCase().includes(keyword))
    );
    
    if (optionIndex === -1) return selectedValue;
    
    // Find the value in the product's option values that matches (ignoring case and spaces)
    const match = product.options[optionIndex].values.find(val => 
      val.replace(/\s+/g, '').toLowerCase() === selectedValue.replace(/\s+/g, '').toLowerCase()
    );
    return match || selectedValue;
  }

  function renderCaratLookOptions(product, selectedCaratLook = '', selectedSize = '', selectedMetal = '') {
    if (!caratLookGrid) return;
    caratLookGrid.innerHTML = '';

    // Find the carat option index dynamically
    const caratIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('carat') ||
      opt.name.toLowerCase().includes('carat look') ||
      opt.name.toLowerCase().includes('ct')
    );

    if (caratIndex === -1) {
      console.log('No carat look option found in product');
      return;
    }

    // Find indices for metal and size for availability checks
    const metalOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('metal') || 
      opt.name.toLowerCase().includes('color') ||
      opt.name.toLowerCase().includes('material')
    );
    const sizeOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('size') ||
      opt.name.toLowerCase().includes('dimension') ||
      opt.name.toLowerCase().includes('measurement')
    );

    // Get unique carat values from product options (consistent with size rendering)
    const caratValues = product.options[caratIndex].values;

    caratValues.forEach(carat => {
      const btn = document.createElement('button');
      btn.textContent = carat;
      btn.className = 'cart-popup-carat-look-option' + (carat === selectedCaratLook ? ' selected' : '');
      btn.dataset.value = carat;

      // Check availability for this carat option
      const isAvailable = isVariantAvailable(product, selectedSize, selectedMetal, carat, metalOptionIndex, sizeOptionIndex, caratIndex);
      if (!isAvailable) {
        btn.disabled = true;
        btn.classList.add('disabled');
      }

      btn.addEventListener('click', () => {
        document.querySelectorAll('.cart-popup-carat-look-option').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        updateSelectedVariant(product);
        const currentlySelectedMetal = document.querySelector('input[name="metal"]:checked')?.value || selectedMetal;
        const currentlySelectedSize = document.querySelector('.cart-popup-size-option.selected')?.dataset.value || selectedSize;
        updateVariantImage(product, currentlySelectedSize, currentlySelectedMetal, btn.dataset.value);
      });

      caratLookGrid.appendChild(btn);
    });
  }

  updateButton.addEventListener('click', () => {
    const quantity = parseInt(quantitySelect.value);
    
    // Check if product has variants
    const hasVariants = productDataObj && productDataObj.variants && productDataObj.variants.length > 1;
    
    if (!currentItemKey || !currentVariantId) return;
    
    // If no variants, just update quantity
    if (!hasVariants) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: currentItemKey,
          quantity: quantity
        })
      })
        .then(response => response.json())
        .then(cart => {
          console.log('Updated item quantity (no variants):', cart);
          modal.style.display = 'none';
          setTimeout(refreshCartSection, 300);
        })
        .catch(error => {
          console.error('Error updating cart item quantity:', error);
        });
      return;
    }
    
         // If there are variants, proceed with size and metal selection
     let selectedSize = document.querySelector('.cart-popup-size-option.selected')?.dataset.value;
     let selectedMetal = document.querySelector('input[name="metal"]:checked')?.value;
     let selectedCaratLook = document.querySelector('.cart-popup-carat-look-option.selected')?.dataset.value;

     // Check if we have at least one option selected
     if (!selectedSize && !selectedMetal && !selectedCaratLook) return;

    // Normalize selected values to match product data
    selectedSize = getExactOptionValue(productDataObj, 'size', selectedSize);
    selectedMetal = getExactOptionValue(productDataObj, 'color', selectedMetal) || getExactOptionValue(productDataObj, 'metal', selectedMetal);
    selectedCaratLook = getExactOptionValue(productDataObj, 'carat', selectedCaratLook);

    // Debugging: log the normalized selected size and metal
    console.log('Normalized Selected Size:', selectedSize);
    console.log('Normalized Selected Metal:', selectedMetal);

    let newVariantId = null;
    let propertiesChanged = false;

    if (productDataObj && productDataObj.variants && productDataObj.options) {
      // Find option indices dynamically
      const metalIndex = productDataObj.options.findIndex(opt => 
        opt.name.toLowerCase().includes('color') || 
        opt.name.toLowerCase().includes('metal') ||
        opt.name.toLowerCase().includes('material')
      );
      const sizeIndex = productDataObj.options.findIndex(opt => 
        opt.name.toLowerCase().includes('size') ||
        opt.name.toLowerCase().includes('dimension') ||
        opt.name.toLowerCase().includes('measurement')
      );
      const caratIndex = productDataObj.options.findIndex(opt => 
        opt.name.toLowerCase().includes('carat') ||
        opt.name.toLowerCase().includes('carat look') ||
        opt.name.toLowerCase().includes('ct')
      );

      console.log('All variants:', productDataObj.variants.map(v => ({ id: v.id, options: v.options })));
      console.log('Selected metal:', selectedMetal, 'Selected size:', selectedSize);
      console.log('Metal index:', metalIndex, 'Size index:', sizeIndex);

             // Look for a variant that matches the selected options
       let match = null;
       
       if (metalIndex !== -1 && sizeIndex !== -1 && caratIndex !== -1 && selectedMetal && selectedSize && selectedCaratLook) {
         // All three options exist and selected
         match = productDataObj.variants.find(variant =>
           variant.options[metalIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase() &&
           variant.options[sizeIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase() &&
           variant.options[caratIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
         );
       } else if (metalIndex !== -1 && sizeIndex !== -1 && selectedMetal && selectedSize) {
         // Both options exist and both are selected
         match = productDataObj.variants.find(variant =>
           variant.options[metalIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase() &&
           variant.options[sizeIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase()
         );
       } else if (metalIndex !== -1 && caratIndex !== -1 && selectedMetal && selectedCaratLook) {
         // Metal + Carat selected
         match = productDataObj.variants.find(variant =>
           variant.options[metalIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase() &&
           variant.options[caratIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
         );
       } else if (sizeIndex !== -1 && caratIndex !== -1 && selectedSize && selectedCaratLook) {
         // Size + Carat selected
         match = productDataObj.variants.find(variant =>
           variant.options[sizeIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase() &&
           variant.options[caratIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
         );
       } else if (metalIndex !== -1 && selectedMetal) {
         // Only metal option exists and is selected
         match = productDataObj.variants.find(variant =>
           variant.options[metalIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase()
         );
       } else if (sizeIndex !== -1 && selectedSize) {
         // Only size option exists and is selected
         match = productDataObj.variants.find(variant =>
           variant.options[sizeIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase()
         );
       } else if (caratIndex !== -1 && selectedCaratLook) {
         // Only carat option exists and is selected
         match = productDataObj.variants.find(variant =>
           variant.options[caratIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
         );
       }

      if (match) {
        newVariantId = match.id;
      }

      // Debugging: log the matched variant
      console.log('Matched Variant:', newVariantId);
    }

    // Log the variant IDs for comparison
    console.log('Current variant ID:', currentVariantId, 'New variant ID:', newVariantId);

    // Fetch cart data before proceeding
    fetch('/cart.js')  // This will fetch the current cart data
      .then(response => response.json())
      .then(cart => {
        console.log('Fetched Cart Data:', cart);

        // Ensure cart items are available
        if (!cart || !cart.items || cart.items.length === 0) {
          console.error('Cart items are not available or empty.');
          return;  // Exit if cart items are not available
        }

                 // Check if the properties (size or metal) are different from what is already in the cart
         if (newVariantId === currentVariantId) {
           // Check if the properties have changed (size or metal)
           const currentProperties = cart.items.find(item => item.key === currentItemKey)?.properties;
           if (currentProperties) {
             const metalChanged = selectedMetal && currentProperties.metal !== selectedMetal;
             const sizeChanged = selectedSize && currentProperties.size !== selectedSize;
              const caratChanged = selectedCaratLook && (currentProperties['carat look'] !== selectedCaratLook);
              if (metalChanged || sizeChanged || caratChanged) {
               propertiesChanged = true;
             }
           }
         }

        // If the variant has changed or the properties have changed, remove the old item and add the new one
        if ((newVariantId && newVariantId !== currentVariantId) || propertiesChanged) {
          // Remove the old item
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: currentItemKey, // This must be the line item key!
              quantity: 0
            })
          })
            .then(res => res.json())
            .then(changeRes => {
              console.log('Removed old item:', changeRes);
              // Add the new variant
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                                 body: JSON.stringify({
                   id: newVariantId,
                   quantity: quantity,
                   properties: {
                     ...(selectedMetal && { metal: selectedMetal }),
                      ...(selectedSize && { size: selectedSize }),
                      ...(selectedCaratLook && { 'carat look': selectedCaratLook })
                   }
                 })
              });
            })
            .then(response => response.json())
            .then(cartItem => {
              console.log('Added new item:', cartItem);
              modal.style.display = 'none';
              setTimeout(refreshCartSection, 300); // Wait a bit before refreshing
            })
            .catch(error => {
              console.error('Error updating cart item:', error);
            });
        } else {
          // If the variant is the same, just update quantity/properties
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
                         body: JSON.stringify({
               id: currentItemKey,
               quantity: quantity,
               properties: {
                 ...(selectedMetal && { metal: selectedMetal }),
                 ...(selectedSize && { size: selectedSize }),
                 ...(selectedCaratLook && { 'carat look': selectedCaratLook })
               }
             })
          })
            .then(response => response.json())
            .then(cart => {
              console.log('Updated item (same variant):', cart);
              modal.style.display = 'none';
              setTimeout(refreshCartSection, 300);
            })
            .catch(error => {
              console.error('Error updating cart item:', error);
            });
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  });


  function formatPrice(priceInCents) {
    return new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED' }).format(priceInCents / 100);
  }

  function getOptionValue(options, key) {
    key = key.toLowerCase();
    // Support multiple option type keywords
    const optionKeywords = {
      'size': ['size', 'dimension', 'measurement'],
      'metal': ['metal', 'color', 'material'],
      'color': ['color', 'metal', 'material'],
      'carat': ['carat', 'carat look', 'ct']
    };
    
    const keywords = optionKeywords[key] || [key];
    const match = options.find(opt => 
      keywords.some(keyword => opt.name.toLowerCase().includes(keyword))
    );
    return match ? match.value?.trim() : '';
  }

  function renderMetalSwatches(product, selectedSize = '', selectedMetal = '', selectedCaratLook = '') {
    // Clear any existing swatches
    metalSwatches.innerHTML = '';

    // Find the metal/color option index dynamically
    const metalOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('metal') || 
      opt.name.toLowerCase().includes('color') ||
      opt.name.toLowerCase().includes('material')
    );

    if (metalOptionIndex === -1) {
      console.log('No metal/color option found in product');
      return;
    }

    // Also find size and carat indices for availability checks
    const sizeOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('size') ||
      opt.name.toLowerCase().includes('dimension') ||
      opt.name.toLowerCase().includes('measurement')
    );
    const caratOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('carat') ||
      opt.name.toLowerCase().includes('carat look') ||
      opt.name.toLowerCase().includes('ct')
    );

    // Get unique metal options from the product variants
    const metalOptions = [...new Set(product.variants.map(v => v.options[metalOptionIndex]))];

    // Loop through each unique metal option
    metalOptions.forEach(metal => {
      console.log("metalOptions", metalOptions.length)
      const id = 'metal-' + metal.toLowerCase().replace(/\s+/g, '-');  // Generate a unique ID for the metal swatch
      const label = document.createElement('label');
      label.className = 'cart-popup-metal-swatch';
      label.setAttribute('for', id);
      label.title = metal;

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'metal';
      input.value = metal;
      input.id = id;
      input.checked = metal.toLowerCase() === selectedMetal.toLowerCase();  // Check if this metal is the selected one

      // Check if the variant is available for this metal (with or without size)
      const isAvailable = isVariantAvailable(product, selectedSize, metal, selectedCaratLook, metalOptionIndex, sizeOptionIndex, caratOptionIndex);
      if (!isAvailable) {
        input.disabled = true;  // Disable if variant is not available
        label.classList.add('disabled'); // Optional: Add a disabled class for styling
      }

      // Event listener for when the user selects a different metal
      input.addEventListener('change', () => {
        // Update the selected metal on change
        updateSelectedVariant(product);

        // Dynamically update the image for the selected variant
        const currentlySelectedSize = document.querySelector('.cart-popup-size-option.selected')?.dataset.value || selectedSize;
        const currentlySelectedCarat = document.querySelector('.cart-popup-carat-look-option.selected')?.dataset.value || selectedCaratLook;
        updateVariantImage(product, currentlySelectedSize, metal, currentlySelectedCarat);

        // Update the metal name display
        if (metalNameEl) {
          metalNameEl.textContent = metal;  // Update the displayed metal name
        }

        // Add 'selected' class to the label
        document.querySelectorAll('.cart-popup-metal-swatch').forEach(swatch => {
          swatch.classList.remove('selected');  // Remove 'selected' class from all swatches
        });

        label.classList.add('selected');  // Add 'selected' class to the clicked swatch
      });

      // Create the image element dynamically based on the handle
      const img = document.createElement('img');
      const formattedMetal = metal.toLowerCase().replace(/\s+/g, '-'); // Format the metal name for URL
      const imageUrl = `https://cdn.shopify.com/s/files/1/0889/4850/6922/files/${formattedMetal}.png`; // Use product handle for the image URL
      img.src = imageUrl;
      img.alt = `${metal} Metal`;
      img.className = 'swatch-image';  // Optional: add a class for styling

      // Add the input and image to the label
      label.appendChild(input);
      label.appendChild(img);  // Add the image to the label

      // Append the label to the metal swatches container
      metalSwatches.appendChild(label);

      // Add the 'selected' class to the default selected swatch
      if (input.checked) {
        label.classList.add('selected');  // Add the selected class to the initially selected swatch
      }
    });
  }

  function renderSizeOptions(product, selectedSize = '', selectedMetal = '', selectedCaratLook = '') {
    sizeGrid.innerHTML = '';
    
    // Find the size option index dynamically
    const sizeIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('size') ||
      opt.name.toLowerCase().includes('dimension') ||
      opt.name.toLowerCase().includes('measurement')
    );
    
    if (sizeIndex === -1) {
      console.log('No size option found in product');
      return;
    }

    product.options[sizeIndex].values.forEach(size => {
      const btn = document.createElement('button');
      btn.textContent = size;
      btn.className = 'cart-popup-size-option' + (size === selectedSize ? ' selected' : '');
      btn.dataset.value = size;

      // Find metal option index for availability check (if it exists)
      const metalOptionIndex = product.options.findIndex(opt => 
        opt.name.toLowerCase().includes('metal') || 
        opt.name.toLowerCase().includes('color') ||
        opt.name.toLowerCase().includes('material')
      );

      // Disable the button if the variant is not available
      const isAvailable = isVariantAvailable(product, size, selectedMetal, selectedCaratLook, metalOptionIndex, sizeIndex);
      if (!isAvailable) {
        btn.disabled = true;  // Disable if variant is not available
        btn.classList.add('disabled'); // Optional: Add a disabled class for styling
      }

      btn.addEventListener('click', () => {
        document.querySelectorAll('.cart-popup-size-option').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        updateSelectedVariant(product);
        const currentlySelectedMetal = document.querySelector('input[name="metal"]:checked')?.value || selectedMetal;
        const currentlySelectedCarat = document.querySelector('.cart-popup-carat-look-option.selected')?.dataset.value || selectedCaratLook;
        updateVariantImage(product, btn.dataset.value, currentlySelectedMetal, currentlySelectedCarat);
      });

      sizeGrid.appendChild(btn);
    });
  }

  function isVariantAvailable(product, size, metal, caratLook, metalOptionIndex = -1, sizeOptionIndex = -1, caratOptionIndex = -1) {
    return product.variants.some(variant => {
      let matches = true;
      if (metalOptionIndex !== -1 && metal) {
        matches = matches && variant.options[metalOptionIndex]?.replace(/\s+/g, '').toLowerCase() === metal.replace(/\s+/g, '').toLowerCase();
      }
      if (sizeOptionIndex !== -1 && size) {
        matches = matches && variant.options[sizeOptionIndex]?.replace(/\s+/g, '').toLowerCase() === size.replace(/\s+/g, '').toLowerCase();
      }
      if (caratOptionIndex !== -1 && caratLook) {
        matches = matches && variant.options[caratOptionIndex]?.replace(/\s+/g, '').toLowerCase() === caratLook.replace(/\s+/g, '').toLowerCase();
      }
      return matches && variant.available;
    });
  }

  // Define the updateVariantImage function to update the product image dynamically
  function updateVariantImage(product, selectedSize, selectedMetal, selectedCaratLook) {
    const imageElement = document.getElementById('popup-image'); // Target the image element

    if (!product || !product.variants) return; // Exit if no product data or variants available

    // Determine option indices dynamically
    const metalOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('metal') || 
      opt.name.toLowerCase().includes('color') ||
      opt.name.toLowerCase().includes('material')
    );
    const sizeOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('size') ||
      opt.name.toLowerCase().includes('dimension') ||
      opt.name.toLowerCase().includes('measurement')
    );
    const caratOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('carat') ||
      opt.name.toLowerCase().includes('carat look') ||
      opt.name.toLowerCase().includes('ct')
    );

    // Find the selected variant by matching available selected options
    let variant;
    variant = product.variants.find(v => {
      let matches = true;
      if (metalOptionIndex !== -1 && selectedMetal) {
        matches = matches && v.options[metalOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase();
      }
      if (sizeOptionIndex !== -1 && selectedSize) {
        matches = matches && v.options[sizeOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase();
      }
      if (caratOptionIndex !== -1 && selectedCaratLook) {
        matches = matches && v.options[caratOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase();
      }
      return matches;
    });

    if (variant && variant.featured_image) {
      imageElement.src = variant.featured_image.src; // Set the image URL to the variant's featured image
      imageElement.alt = `${variant.title} Variant`;  // Update the alt text for accessibility
    }
  }

  function updateSelectedVariant(product) {
    const selectedMetal = document.querySelector('input[name="metal"]:checked')?.value;
    const selectedSize = document.querySelector('.cart-popup-size-option.selected')?.dataset.value;
    const selectedCaratLook = document.querySelector('.cart-popup-carat-look-option.selected')?.dataset.value;

    // Find metal and size option indices dynamically
    const metalOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('metal') || 
      opt.name.toLowerCase().includes('color') ||
      opt.name.toLowerCase().includes('material')
    );
    
    const sizeOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('size') ||
      opt.name.toLowerCase().includes('dimension') ||
      opt.name.toLowerCase().includes('measurement')
    );
    const caratOptionIndex = product.options.findIndex(opt => 
      opt.name.toLowerCase().includes('carat') ||
      opt.name.toLowerCase().includes('carat look') ||
      opt.name.toLowerCase().includes('ct')
    );

    let match = null;

    // Handle different scenarios based on which options exist (prefer most specific)
    if (metalOptionIndex !== -1 && sizeOptionIndex !== -1 && caratOptionIndex !== -1 && selectedMetal && selectedSize && selectedCaratLook) {
      match = product.variants.find(variant =>
        variant.options[metalOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase() &&
        variant.options[sizeOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase() &&
        variant.options[caratOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
      );
    }
    if (!match && metalOptionIndex !== -1 && sizeOptionIndex !== -1 && selectedMetal && selectedSize) {
      match = product.variants.find(variant =>
        variant.options[metalOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase() &&
        variant.options[sizeOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase()
      );
    }
    if (!match && metalOptionIndex !== -1 && caratOptionIndex !== -1 && selectedMetal && selectedCaratLook) {
      match = product.variants.find(variant =>
        variant.options[metalOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase() &&
        variant.options[caratOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
      );
    }
    if (!match && sizeOptionIndex !== -1 && caratOptionIndex !== -1 && selectedSize && selectedCaratLook) {
      match = product.variants.find(variant =>
        variant.options[sizeOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase() &&
        variant.options[caratOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
      );
    }
    if (!match && metalOptionIndex !== -1 && selectedMetal) {
      match = product.variants.find(variant =>
        variant.options[metalOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedMetal.replace(/\s+/g, '').toLowerCase()
      );
    }
    if (!match && sizeOptionIndex !== -1 && selectedSize) {
      match = product.variants.find(variant =>
        variant.options[sizeOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedSize.replace(/\s+/g, '').toLowerCase()
      );
    }
    if (!match && caratOptionIndex !== -1 && selectedCaratLook) {
      match = product.variants.find(variant =>
        variant.options[caratOptionIndex]?.replace(/\s+/g, '').toLowerCase() === selectedCaratLook.replace(/\s+/g, '').toLowerCase()
      );
    }

    if (match) {
      priceEl.textContent = formatPrice(match.price);
      oldPriceEl.textContent = match.compare_at_price > match.price ? formatPrice(match.compare_at_price) : '';
      currentVariantId = match.id;
    }
  }
});


function refreshCartSection() {
  // Fetch main-cart-items
  fetch(window.location.pathname + '?section_id=main-cart-items')
    .then(res => res.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Get the new main-cart-items section
      const newCartSection = tempDiv.querySelector('#main-cart-items');
      const oldCartSection = document.querySelector('#main-cart-items');

      // Update the main-cart-items if the new content is available
      if (newCartSection && oldCartSection) {
        oldCartSection.replaceWith(newCartSection);
      }
    })
    .then(() => {
      // Fetch main-cart-footer after main-cart-items has been updated
      fetch(window.location.pathname + '?section_id=main-cart-footer')
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          // Get the new main-cart-footer section
          const newFooterSection = tempDiv.querySelector('#main-cart-footer');
          const oldFooterSection = document.querySelector('#main-cart-footer');

          // Update the main-cart-footer if the new content is available
          if (newFooterSection && oldFooterSection) {
            oldFooterSection.replaceWith(newFooterSection);
          }

          // Re-initialize the currency converter after the content update
          if (typeof window.hwCurrencyConverterLoad === 'function') {
            window.hwCurrencyConverterLoad();
          }
        });
    });
}

